<template>
  <div class="xcard">
    <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn> -->
    <p class="my-1">
      <b>ID/Sede:</b> {{ this.$store.state.CARGO.sede.id }} - {{ this.$store.state.CARGO.sede.nombre }}
    </p>
    <b>Sucursales: </b>
    <v-progress-linear indeterminate v-if="loadingsucursales" class="green" />
    <v-row no-gutters>
      <v-col v-for="(se, ind) in sucursales" :key="ind" class="mb-0 pl-4" sm="3">
        <p class="mb-0">
          <small>
            <b> [Nro. {{ se.sucursal.numero_sucursal }}]</b> nit: {{ se.sucursal.nro_nit }}
          </small>
        </p>
        <p v-if="se.punto_venta.nombre">
          <small>
            <b>[{{ se.punto_venta.codigo_punto_venta }}]</b> {{ se.punto_venta.nombre }} -
            {{ se.punto_venta.descripcion }}
          </small>
        </p>
        <p v-else class="ma-0">
          <small class="ml-0"><b>Sin punto de venta</b></small>
        </p>
      </v-col>
    </v-row>

    <v-col cols="12"> </v-col>

    <template>
      <p class="mb-0"><b>Facturas del sector educativo</b></p>
      <v-row>
        <v-col cols="12" sm="4">
          <v-select
            :items="meses"
            v-model="xmes"
            label="Seleccione Mes:"
            item-value="id"
            outlined
            dense
            clearable
            hide-details />
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
            :items="gestiones"
            v-model="xanio"
            label="Gestion:"
            item-value="id"
            outlined
            dense
            clearable
            hide-details />
        </v-col>
        <v-col cols="12" sm="5">
          <v-select
            v-model="docsector"
            :items="docssector"
            label="Documento Sector"
            item-value="id"
            outlined
            dense
            hide-details />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="suc_sel"
            :items="sucursales"
            item-text="xtext"
            label="Seleccione el nit"
            return-object
            class=""
            outlined
            dense
            hide-details />
        </v-col>
        <v-col>
          <v-text-field 
          v-model="search" 
          label="Nro. Fact. / Razon..." 
          class="mx-4" 
          hide-details
          outlined
          dense
          append-icon="mdi-file-search"
          clearable
          v-on:keyup.enter="getdatos(suc_sel)"
          @click:clear="getdatosClear(suc_sel)"
          @click:append="getdatos(suc_sel)"
          />
        </v-col>
      </v-row> 
      <v-data-table
        :headers="headers"
        :items="desserts"
        :loading="loading"
        :search="search"
        :options.sync="options"
        :server-items-length="totalDesserts"
        :items-per-page="size"
        :items-per-page-options="[5,15,-1]"
        disable-items-per-page
        sort-by="calories"
        class="elevation-1">
        <template v-slot:[`item.numeroFactura`]="{ item }">
          <span> {{ item.numeroFactura?item.numeroFactura:item.nroFactura }} </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2 orange--text" small v-bind="attrs" v-on="on" @click="verItem(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver Factura </span>
          </v-tooltip> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2 green--text" small v-bind="attrs" v-on="on" @click="visualizarpdf(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver PDF de Factura </span>
          </v-tooltip>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2 green--text" small v-bind="attrs" v-on="on" @click="generarnotadc(item)">
                mdi-cash-100
              </v-icon>
            </template>
            <span> Generar Nota Debito Credito </span>
          </v-tooltip> -->

          <v-tooltip bottom v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2 green--text" small v-bind="attrs" v-on="on" @click="verificarestado(item)">
                mdi-check-decagram
              </v-icon>
            </template>
            <span> Verificar Estado </span>
          </v-tooltip>

          <v-tooltip bottom v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="isanuladacheck(item)"
                class="mr-0 red--text"
                small
                v-bind="attrs"
                v-on="on"
                @click="abrirAnularFactura(item)">
                mdi-delete
              </v-icon>
            </template>
            <span> Anular Factura </span>
          </v-tooltip>
        </template>
      </v-data-table>
      <download-excel
        :disabled="desserts.length == 0"
        class="btn btn-azul"
        :data="desserts"
        :fields="json_fields"
        worksheet="Facturas"
        :stringifyLongNum="true"
        name="facturas.xls">
        <v-icon class="ma-0" color="white">mdi-download</v-icon> Descargar Datos en excel
      </download-excel>
    </template>

    <Registrar ref="registrar" v-on:facturageneradax="facturageneradax" />
    <Verfactura ref="verfactura" />
    <GenerarNota ref="generarnota" />
    <EventoViewFactura ref="verfacturaevento" />
    <Anular ref="anularfactura" v-on:anuladofact="anuladofact" />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import Registrar from '@/views/rfacturascv/registrar.vue';
  import Verfactura from '@/views/rfacturascv/verfactura.vue';
  import EventoViewFactura from '@/views/recibos/esignificativos/eventoviewfactura.vue';
  import Anular from '@/views/recibos/AnularFE.vue';
  import GenerarNota from '@/views/rfacturascv/regnota.vue';
  import gql from 'graphql-tag';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loadingsucursales: false,
      loading: false,
      sucursales: [],
      gestiones: [],
      nits: [],
      search: '',
      xmes: null,
      xanio: null,
      suc_sel: null,
      headers: [
        { text: 'Numero Factura', value: 'numeroFactura', width: 40 },
        { text: 'Razon Social', value: 'nombreRazonSocial' },
        /* { text: 'Estudiante', value: 'nombreEstudiante' },
      { text: 'Doc.', value: 'numeroDocumento' }, */
        { text: 'Monto total', value: 'montoTotal' },
        { text: 'Correo', value: 'email' },
        // { text: 'Codigo Recepcion', value: 'codigoRecepcion' },
        { text: 'Estado', value: 'estado' },
        { text: 'Opciones', value: 'actions', sortable: false, width: 120 },
      ],
      desserts: [],
      desserts2: [],
      //
      json_fields: {
        'Numero Factura': 'numeroFactura',
        'Razon Social': 'nombreRazonSocial',
        'Monto total': 'montoTotal',
        Correo: 'email',
        'Codigo Recepcion': 'codigoRecepcion',
        ESTADO: 'estado',
        'Codigo Anulacion': 'codigoAnulacion',
        'Codigo Documento Sector': 'codigoDocumentoSector',
        'Email Estado': 'emailEstado',
        'Fecha Emision': 'fechaEmision',
        Nit: 'nit',
        'Nombre Estudiante': 'nombreEstudiante',
        'Nombre Razon Social': 'nombreRazonSocial',
        'Numero Documento': 'numeroDocumento',
        'Periodo Facturado': 'periodoFacturado',
        Telefono: 'telefono',
        Usuario: 'usuario',
      },
      json_meta: [[{ key: 'charset', value: 'utf-8' }]],
      options: {itemsPerPage:15},
      totalDesserts: 0,
      size: 15,
      presave_suc: null,
      meses: [
        { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' },
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' },
      ],
      docssector: [
        // { id: 1, text: 'COMPRA Y VENTA' },
        { id: 11, text: 'SECTOR EDUCATIVO' },
        { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' },
        // monto sujeto iva cuando es  46
      ],
      docsector: 11,
    }),

    components: { Registrar, Verfactura, EventoViewFactura, Anular, GenerarNota },
    watch: {
      '$store.state.CARGO.sede': function () {
        this.getSucursalesBySede();
      },
      xmes: function () {
        this.getdatos(this.suc_sel);
      },
      xanio: function () {
        this.getdatos(this.suc_sel);
      },
      suc_sel: function () {
        // window.console.log(this.suc_sel);
        this.getdatos(this.suc_sel);
      },
      docsector: function () {
        this.getdatos(this.suc_sel);
      },
      options: {
        handler() {
          //window.console.log('options', this.options);
          this.getdatos(this.presave_suc, false);
        },
        deep: true,
      },
    },
    created() {
      this.initialize();
      // demo
      // this.getLeyendas(1);
    },

    methods: {
      initialize() {
        const date = new Date();
        this.xmes = date.getMonth()+1;
        this.xanio = date.getFullYear();
        this.getGestiones();
        this.getSucursalesBySede();
      },
      getSucursalesBySede() {
        let sedeid = this.$store.state.CARGO.idsede;
        let vue = this;
        this.sucursales = [];
        this.desserts = [];
        this.desserts2 = [];
        vue.loadingsucursales = true;

        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`;
        let url2 = `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`;
        const promise = xaxios.get(url);
        const promise2 = xaxios.get(url2);

        Promise.all([promise, promise2])
          .then(function (values) {
            let data = values[0].data.data;

            let data2 = values[1].data.data;
            data2.map((x) => {
              x.xtext = `${x.nro} [${x.tipo_facturacion}]`;
            });
            let xxxnits = [];

            data.map((x) => {
              x.xtext = `${x.sucursal.nro_nit} [${x.sucursal.numero_sucursal}]`;
              let n = data2.find((n) => n.nro == x.sucursal.nro_nit);
              x.xnit = n;
              if (!n || !n.apikey) x.xnit = { apikey: 'nro_nit_apikey_not_found' };
              xxxnits.push(n);
            });

            vue.nits = xxxnits;
            vue.sucursales = data;
            vue.loadingsucursales = false;
            vue.suc_sel = vue.sucursales[0];
            // vue.getdatos(vue.sucursales[1]);
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },

      getGestiones() {
        this.$apollo
          .query({
            query: gql`
              query {
                getGestiones {
                  gestion
                }
              }
            `,
          })
          .then(({ data: { getGestiones } }) => {
            const data = getGestiones.reverse();
            data.map((x) => {
              x.id = x.gestion;
              x.text = x.gestion;
            });
            this.gestiones = data;
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      resetPage(){
        this.options.page = 0;
      },
      getdatosClear(){
        this.search = '';
        this.getdatos(this.suc_sel);
      },
      getdatos(sucursal, reset = true) {
        // window.console.log(sucursal, reset);
        if (!sucursal) return;
        if(reset) this.resetPage();
        this.presave_suc = { ...sucursal };
        this.desserts = [];
        this.desserts2 = [];
        let vue = this;
        this.loading = true;
        let documentoSector = this.docsector;
        let page = this.options.page;
        let zmes = '';
        let zanio = '';
        let zbus = '';
        if (!page) page = 0;
        else page -= 1;
        if(this.xmes) zmes = `&mes=${this.xmes}`;
        if(this.xanio) zanio = `&anio=${this.xanio}`;
        if(this.search) zbus = `&busqueda=${this.search}`;
        vue.size = this.options.itemsPerPage;
        if(vue.size < 0 ) vue.size = 150000; // max 

        var config = {
          method: 'get',
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas`,
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/documentosector/${documentoSector}`,
          // url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sucursal/${sucursal.sucursal.numero_sucursal}/puntoventa/${sucursal.punto_venta.codigo_punto_venta}/documentosector/${documentoSector}`,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sucursal/${sucursal.sucursal.numero_sucursal}/puntoventa/${sucursal.punto_venta.codigo_punto_venta}/documentosector/${documentoSector}?page=${page}&size=${vue.size}${zmes}${zanio}${zbus}`,
          headers: {
            //apikey: this.$store.getters.getApiKey,
            apikey: sucursal.xnit.apikey,
          },
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data;
            let datos = data;
            // window.console.log(response.data);
            if(data.data) {
              data = data.data;
              data.content.forEach(x=>{
                x.numeroFactura = x.numeroFactura?x.numeroFactura:x.nroFactura;
                x.codigoDocumentoSector = x.codigoDocumentoSector?x.codigoDocumentoSector:x.codigoTipoDocumentoSector;
                x.numeroDocumento = x.numeroDocumento?x.numeroDocumento:x.nroDocumentoIdentidad;
                if(x.camposEspecificos){
                  let est = x.camposEspecificos.nombreEstudiante;
                  let per = x.camposEspecificos.periodoFacturado;
                  x.nombreEstudiante = est;
                  x.periodoFacturado = per;
                }
              });
              datos = data.content;
              vue.totalDesserts = data.totalElements;
            }else {
              vue.totalDesserts = datos.length;
            }

            vue.desserts = datos;
            vue.desserts2 = datos;
            vue.loading = false;
            //vue.filtrarpormes();
          })
          .catch(function (error) {
            vue.loading = false;
            window.console.log(error);
          });
      },

      newregsucursal() {
        this.initialize();
      },
      editItem() {
        let sucursal = this.sucursales[0];
        this.$refs.registrar.showThisView(sucursal);
      },
      isanuladacheck(item) {
        if (item.estado.includes('ANULACION CONFIRMADA')) return true;
        return false;
      },
      verItem(item) {
        this.$refs.verfacturaevento.openmodal(item);
      },
      generarnotadc(item) {
        this.$refs.generarnota.openmodal(item);
      },
      abrirAnularFactura(item) {
        this.$refs.anularfactura.openmodal(item);
      },
      facturageneradax(data) {
        this.initialize();
        this.$refs.verfactura.openmodal(data);
      },
      visualizarpdf(item) {
        //window.console.log("ver fact suc_sel",this.suc_sel);
        let fact = { venta: item, xapikey: this.suc_sel.xnit.apikey };
        this.$refs.verfactura.openmodal(fact);
      },
      anuladofact() {
        this.initialize();
      },
      verificarestado(item) {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Verificar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar',
          body: '<br> <b>NOTA:</b> Esta accion es irreversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function (dialog) {
            vue.verificarestado2(item, dialog);
          })
          .catch(function () {});
      },
      verificarestado2(item, dialog) {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/verificar/${item.id}`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: vue.suc_sel.xnit.apikey,
          },
        };

        xaxios.request(config)
          .then(function (response) {
            window.console.log('response', response);
            dialog.close();
            vue.initialize();
            let data = response.data.respuestaServicioFacturacion;
            let mensaje = 'Descripcion: ' + data.codigoDescripcion;

            vue.$root.$notify.show(mensaje, { color: 'success' });
          })
          .catch(function (error) {
            window.console.log(error);
            dialog.close();
            let data = error.response.data.respuestaServicioFacturacion;
            let mensaje = data.mensaje;
            let txt = data.codigoDescripcion;
            if (mensaje) txt += ` Error ${mensaje}`;
            else txt += ` ${data.mensajesList[0].codigo} - ${data.mensajesList[0].descripcion}`;
            vue.$root.$notify.show(txt, { color: 'red' });
          });
      },
      filtrarpormes() {
        let vue = this;
        let zmes = (this.xmes + '').padStart(2, '0');
        window.console.log('zmes::',zmes);
        this.desserts = this.desserts2.filter((x) => {
          if (!vue.xmes) return true;
          if (x.fechaEmision.includes(`/${zmes}/`)) return true;
          return false;
        });
      },
    },
  };
</script>
